const normalizeQueryValue = (value) => {
  const normalized = String(value || "").trim();

  return normalized && !["null", "undefined"].includes(normalized.toLowerCase())
    ? normalized
    : null;
};

export const normalizeReturnFlowType = (value) => {
  const normalized = normalizeQueryValue(value)?.toLowerCase();

  if (normalized === "return") {
    return "return";
  }

  if (normalized === "exchange") {
    return "exchange";
  }

  if (["replacement", "replace"].includes(normalized)) {
    return "replacement";
  }

  if (["warranty", "warrenty", "warranty_claim"].includes(normalized)) {
    return "warranty";
  }

  return null;
};

export const getReturnFlowDeepLink = (params) => {
  const lineItemId = normalizeQueryValue(params?.get?.("line_item_id"));
  const returnType = normalizeReturnFlowType(params?.get?.("return_type"));

  return lineItemId && returnType ? { lineItemId, returnType } : null;
};
